import { api } from "./api.js";
import { go } from "./router.js";

// First launch runs Splash → How it works → Landing → Age gate → Allow messages. After that the app
// opens straight in the lobby. The server keeps it on the player's account (it also records when they
// confirmed 18+ and accepted the terms); the phone keeps a copy so the lobby opens without waiting.
const KEY = "dd_onboarded";

export function isOnboarded(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function rememberOnboarded(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* private mode: the server still knows */
  }
}

export function saveOnboarded(): void {
  void api("/v1/onboarded", { method: "POST" }).catch(() => {});
}

export function finishOnboarding(): void {
  rememberOnboarded();
  saveOnboarded();
  go("App09", true);
}
